import * as zod from 'zod';

export const RobotiqEPickCommand = zod.object({
  kind: zod.literal('RobotiqEPickCommand'),
  controlKind: zod.enum(['grip', 'release']),
  mode: zod.enum(['auto', 'advanced']),
  // Grip params
  forcePercent: zod.number().optional(),
  minForcePercent: zod.number().optional(),
  timeoutMS: zod.number().optional(),
  // Release params
  blowOffPressurePercent: zod.number().optional(),
});

export type RobotiqEPickCommand = zod.infer<typeof RobotiqEPickCommand>;
